import React from 'react';
import clsx from 'clsx';
import * as classes from './Lists.module.scss';

const copyList = <L extends 'ul' | 'ol', T extends HTMLElementTagNameMap[L] = HTMLElementTagNameMap[L]>(List: L) => {
    const component = React.forwardRef<T, L extends 'ul' ? React.HTMLAttributes<T> : React.OlHTMLAttributes<T>>((props, ref) => {
        const { className, ...rest } = props;
        const mergedClassName = clsx(classes[List], className);
        // @ts-ignore
        return <List {...rest} className={mergedClassName} ref={ref} />;
    });
    component.displayName = List;
    return component;
};

export const Ul = copyList('ul');
export const Ol = copyList('ol');
